import { Button, PageHeader } from 'components';
import { Form, Row, Col, Typography } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import ImagesSection from './formSections/images';
import CheckboxesSection from './formSections/checkboxes';
import CommunicationsCheckboxes from './formSections/communicationsCheckboxes';
import { useTranslation } from 'react-i18next';
import useExtraSales from '../useExtraSales';
import FormHelper from 'helpers/FormHelper';

const CompanyCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    filterData,
    form,
    handleDeleteFile,
    updateInProcess,
    singleItem,
    handleCreateOrUpdate,
  } = useExtraSales(false, !isNew);
  const onFinish = (values) => {
    handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('Nuova attività per fascia oraria')
    : t('Modifica attività per fascia oraria');

  const extrasaleHours = singleItem?.allData?.extrasale_hours || [];

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            description: '',
            members_quantity: '',
            date_from: '',
            date_to: '',
            membership_expiration_date: '',
            location: '',
            shopping_center_id: '',
            company_category_ids: [],
            time_from: [],
            time_to: [],
            times: isNew ? [{ time_from: '', time_to: '' }] : [],
            is_archive: false,
            is_newsletter: false,
            is_radio: false,
            is_social: false,
            is_web: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection />
          <DateSection />
          <ShopSection
            companyCategories={filterData?.company_categories}
            shoppingCenters={filterData?.shopping_centers}
          />

          <ImagesSection
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
          />
          <DescriptionSection />
          {isNew && <CheckboxesSection />}
          {extrasaleHours.length > 0 && (
            <Row>
              <Col span={6}>
                <Typography.Title level={3}>
                  {t('FASCE ORARIE')}
                </Typography.Title>
              </Col>
              <Col>
                {extrasaleHours.map((hour, index) => (
                  <Typography.Text key={index} style={{ display: 'block' }}>
                    {hour.date_title}
                  </Typography.Text>
                ))}
              </Col>
            </Row>
          )}

          <CommunicationsCheckboxes />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyCategoryEdit;
